import React from "react";

import { useAuthContext } from "../../../auth";
import { useLabels } from "../../../contexts/labels";

export function UserGreeting() {
  const { labels } = useLabels();
  const { userInfo } = useAuthContext();

  const [greetingPart1, greetingPart2] = (
    labels["header-menu-personal-area-authenticated-greeting"] ?? ""
  ).split("{{username}}");

  return (
    <p className="font-light">
      {greetingPart1 ?? ""}
      <strong className="font-bold">
        {[userInfo?.given_name, userInfo?.family_name].filter(Boolean).join(" ")}
      </strong>
      {greetingPart2 ?? ""}
    </p>
  );
}
